// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NWhZC","trademark":"styles_trademark__v3PYc","icons":"styles_icons__i5FKb"};